import { Card, Col, Container, Form, Row, Badge, Button } from "react-bootstrap";
import { userServices } from "../../APIServices/UserData/userServices";
import { IoArrowForward } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { handleResponse } from "../../APIHelpers/Responses";
import { authServices } from "../../APIServices/UserData/authServices";
import { accountServices } from "../../APIServices/PasswordManagement/accountServices";
import { useEffect, useState } from "react";
import { ListLoader } from "../../Hooks/PageLoader";
import { GoOrganization } from "react-icons/go";

export default function SelectAccount({ auth, organizationList, getCurrectLoginUser, accountId, currentUserData, isDark }) {

  const [adminId, setAdminId] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [loader, setLoader] = useState(false);
  const switchLoginAccount = async (item) => {
    if (item?.status === "active") {
      let userData = {};
      userData.loginAccountId = item?.accountId;
      let data = await userServices.switchLoginAccount(auth, userData);
      if (data?.statusCode === 200) {
        getCurrectLoginUser();
      }
    } else {
      await handleResponse({
        statusCode: 400,
        customMessage: "Access denied. This account is currently disabled.",
      })
    }
  };

  const getAccountList = async () => {
    setLoader(true)
    let data = await accountServices.getAccountList(auth, adminId, "all")
    setAccountList(data?.data || [])
    setLoader(false)
  }

  useEffect(() => {
    if (adminId && !accountId) {
      getAccountList()
    }
  }, [auth, adminId]);

  useEffect(() => {
    if (currentUserData?.roleType === "organization") {
      setAdminId(currentUserData?.userId)
    } else {
      if (organizationList?.length === 1) {
        setAdminId(organizationList?.[0]?.adminId)
      }
    }
  }, [currentUserData]);

  const logout = async () => {
    await authServices.logout(auth);
  };

  return (
    <>
      <div className="hstack justify-content-center" style={{ height: "100vh" }}>
        {loader ?
          <ListLoader />
          :
          <div className="w-75 m-auto p-3">
            <Card className="border rounded">
              <Card.Body className="p-0">
                <div className="d-flex justify-content-between pt-3 px-3">
                  <div>
                    <h6 className="fw-bold mb-0">Select Account</h6>
                    <p className="small text-muted">Account store all of your passwords, credit cards, and other items.</p>
                  </div>
                  <Button variant="outline-danger" className="rounded-1 h-100 hstack gap-1" style={{ fontSize: 13 }} onClick={logout} title="logout from pannel"><LuLogOut /> Logout</Button>
                </div>
                <div className="overflow-auto" style={{ maxHeight: "calc(100vh - 154px)" }}>
                  <Container fluid>
                    <Row className="pt-1">
                      {adminId ? (
                        <Form.Group as={Col} md={adminId ? 3 : 12} className={`mb-2`}>
                          {currentUserData?.roleType === "individual" && organizationList?.length > 1 &&
                            <div className="item-list">
                              {organizationList?.map((item, index) => {
                                const isActive = adminId === item?.adminId;
                                return (
                                  <div
                                    key={index}
                                    className={`member-card border ${isActive ? item?.status === "inactive" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                                    onClick={() => setAdminId(item?.adminId)}
                                    role="button"
                                  >
                                    <div className="member-info">
                                      <div className="member-name">
                                        <GoOrganization /> {item?.name}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          }
                        </Form.Group>
                      ) : (currentUserData?.roleType === "individual" && organizationList?.length > 1 &&
                        <div className="item-list" style={{flexDirection : "row"}}>
                          {organizationList?.map((item, index) => {
                            const isActive = adminId === item?.adminId;
                            return (
                              <div
                                key={index}
                                className={`member-card border ${isActive ? item?.status === "inactive" ? "border-danger bg-danger-subtle" : "border-success bg-success-subtle" : ""}`}
                                onClick={() => setAdminId(item?.adminId)}
                                style={{width: 185}}
                                role="button"
                              >
                                <div className="member-info">
                                  <div className="member-name">
                                    <GoOrganization /> {item?.name}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                      <Form.Group as={Col} md={9} className="mb-2">
                        {loader ? (
                          <ListLoader/>
                        ) : (
                          <Row>
                            {accountList?.map((item, index) => (
                              <Form.Group onClick={() => switchLoginAccount(item)} key={index} as={Col} md={4} className="mb-2">
                                <button title={item?.name} className={`category-card w-100 d-block align-items-start overflow-hidden text-start p-0 ${isDark ? "dark" : ""}`}>
                                  <div style={{ fontSize: 14 }} className={`border-bottom py-2 px-3  ${isDark ? "bg-dark" : "bg-light"}`}>
                                    <div className="hstack justify-content-between">
                                      <div className="fw-bold m-0">{item?.name}</div>
                                      <div className="hstack gap-2">
                                        {item?.category === "primary" ?
                                          <Badge bg="primary" className="rounded-1 text-capitalize">{item?.category}</Badge>
                                          : item?.status === "inactive" &&
                                          <Badge bg="outline-secondary" style={{ cursor: "no-drop" }} className="rounded-1 text-muted text-capitalize">Disabled</Badge>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div style={{ fontSize: 13, height: 140 }} className="py-2 px-3 text-muted overflow-auto">
                                    <p className="mb-1">{item?.totalItem}</p>
                                    <p className="mb-1">{item?.totalGroup}</p>
                                    <p>{item?.description}</p>
                                  </div>
                                  <div style={{ fontSize: 14 }} className="border-top py-2 px-3 hstack justify-content-end">
                                    <Badge bg={item?.status === "active" ? "success" : "secondary"} title="Login now" className="rounded-1 text-capitalize">Login <IoArrowForward /></Badge>
                                  </div>
                                </button>
                              </Form.Group>
                            ))}
                          </Row>
                        )}
                      </Form.Group>
                    </Row>
                  </Container>
                </div>
              </Card.Body>
            </Card>
          </div>
        }
      </div>
    </>
  );
}
